import * as filtersHelper from "@/helpers/filters.helper"
import {
  getRuntimeFilter,
  getSeverityFilter,
  InventoryFilters
} from "@/pages/DiscoveryPage/utils/filters.utils"

import type { TFunction } from "@/hooks/useTranslation"
import type { Filters } from "@/organisms/SmartSearch/types/options.types"

export const getItemsFilter = (
  t: TFunction,
  environmentOptions?: { label: string; value: string }[]
): Filters => {
  const keyValues = "filters.helpers.multipleValues"

  return [
    InventoryFilters.application(t),
    InventoryFilters.repositoryName(t),
    InventoryFilters.imageName(t),
    InventoryFilters.environment(t, environmentOptions),
    InventoryFilters.namespace(t),
    InventoryFilters.packageManagers(t),
    getRuntimeFilter(),
    getSeverityFilter(),
    filtersHelper.getVulnerabilityIdFilter(t),
    filtersHelper.getCveIdFilter(t),
    filtersHelper.getHighProfileFilter(t),
    {
      key: "commitHash",
      label: t("filters.commitHash"),
      type: "input",
      helper: [
        {
          label: t(keyValues, { label: t("filters.commitHash") }),
          description: t("inventory.generalFilters.multipleSubstring", {
            name: "commit hashes"
          })
        }
      ]
    },
    {
      key: "contributors",
      label: t("filters.contributors"),
      type: "input",
      helper: [
        {
          label: t(keyValues, { label: t("filters.contributors") }),
          description: t("inventory.generalFilters.multipleSubstring", {
            name: "contributors"
          })
        }
      ]
    },
    filtersHelper.getPackageCategoryAI(t),
    filtersHelper.getIsPackageAiRelated(t)
  ]
}
